import { Component, OnInit, Input, inject } from "@angular/core";
import { provideTranslationScope, TranslatePipe } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/findingreport/i18n/scope";
import { FindingReportDetailsModel } from "@app/findingreport/shared/models";
import { FindingReportDataService } from "@app/findingreport/services";
import { TabService } from "@services/tabs/TabService";
import { Pages } from "@constants/pages/Pages";
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule } from "@angular/forms";
import { DateInputComponent } from "@app/shared/components/date-input/date-input.component";
import { InputTooltipDirective } from "@app/shared/directives/input-tooltip.directive";

@Component({
    selector: "linked-finding-report",
    templateUrl: "./finding-report-linked-summary.component.html",
    styleUrls: ["./finding-report-linked-summary.component.scss"],
    imports: [TranslatePipe, NgSelectModule, FormsModule, DateInputComponent, InputTooltipDirective],
    viewProviders: [provideTranslationScope(scope)],
})
export class FindingReportLinkedSummaryComponent implements OnInit {
    private findingReportService = inject(FindingReportDataService);
    private tabService = inject(TabService);
    private pages = inject(Pages);

    @Input() findingReportGuid: string;
    @Input() showOpenButton = false;

    detailsModel: FindingReportDetailsModel;

    ngOnInit() {
        if (this.findingReportGuid) {
            this.findingReportService.getFindingReport(this.findingReportGuid).subscribe(findingReport => {
                this.detailsModel = findingReport;
            });
        }
    }

    openFindingReport() {
        this.tabService.generateTab(
            this.pages.ImDetail,
            this.detailsModel.guid,
            `(F) ${+this.detailsModel.identifier} - ${this.detailsModel.name}`
        );
    }
}
